import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import {
  AdministrationResultStatus, EmployeeServiceData,
  SecurityResultStatus,
  ServiceCategoryData,
  UserProfileData,
  UserRoleData
} from "../../../clients/system-api/SystemApiClient";
import { SnackBarService } from "../../../services/snack-bar.service";
import { ProfileService } from "../../../services/profile.service";
import { ServiceCategoryService } from "../../../services/service-category.service";

@Component({
  selector: 'app-user-popup',
  templateUrl: './user-popup.component.html',
  styleUrls: ['./user-popup.component.scss']
})
export class UserPopupComponent implements OnInit {

  @Input() userId?: number;

  @Output() close = new EventEmitter<boolean>();
  userForm!: FormGroup
  userProfileData!: UserProfileData
  showError: boolean = false
  roles: UserRoleData[] = []
  windowWidth: any
  showServiceCategories: boolean = false;
  serviceCategories: ServiceCategoryData[] = []
  chosenCategories: number[] = []
  employeeServices: EmployeeServiceData[] = []

  constructor(
    private profileService: ProfileService,
    private serviceCategoryService: ServiceCategoryService,
    private formBuilder: FormBuilder,
    private _snackBarService: SnackBarService) {
  }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      surname: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', [Validators.required]),
      username: new FormControl('', [Validators.required]),
      role: new FormControl(0, [Validators.required, Validators.min(1)]),
      active: new FormControl(true, [Validators.required]),

    });

    this.profileService.retrieveUserRoles().subscribe(result => {
      this.roles = this.userId != undefined ? result.content!.filter(x => x.id != 2) : result.content!;
    });

    if (this.userId !== undefined && this.userId !== null && isNaN(this.userId) == false) {
      this.profileService.retrieveUserById(this.userId!).subscribe(result => {
        if (result.status == AdministrationResultStatus.Success) {
          this.userProfileData = result.content!
          this.userForm.get('name')?.setValue(this.userProfileData.name)
          this.userForm.get('surname')?.setValue(this.userProfileData.surname)
          this.userForm.get('email')?.setValue(this.userProfileData.email)
          this.userForm.get('phone')?.setValue(this.userProfileData.phone)
          this.userForm.get('username')?.setValue(this.userProfileData.username)
          this.userForm.get('role')?.setValue(this.userProfileData.roleId)
          this.userForm.get('active')?.setValue(this.userProfileData.active)
        }

        if (this.userProfileData.employeeServicesList != undefined) {
          this.userProfileData.employeeServicesList?.forEach(x => {
            let existingCategory = this.chosenCategories.filter(category => category == x.serviceCategoryId)
            if (existingCategory.length == 0) {
              this.chosenCategories.push(x.serviceCategoryId!);
              this.retrieveServicesByCategoryId(x.serviceCategoryId!)
            }
          })
          this.onRoleChanged({ value: this.userProfileData.roleId })
        }

      })
    }
  }

  submit() {
    let userProfileData = {
      name: this.userForm.get('name')?.value,
      surname: this.userForm.get('surname')?.value,
      email: this.userForm.get('email')?.value,
      username: this.userForm.get('username')?.value,
      phone: this.userForm.get('phone')?.value,
      roleId: this.userForm.get('role')?.value,
      active: this.userForm.get('active')?.value,
      employeeServicesList: this.employeeServices
    } as UserProfileData

    if (userProfileData.roleId != 2) {
      userProfileData.employeeServicesList = this.employeeServices!;
    }

    if (this.userId != undefined) {
      userProfileData.profileId = this.userProfileData.profileId;
      userProfileData.id = this.userProfileData.id;
    }


    this.userId == undefined ? this.profileService.addUser(userProfileData).subscribe(result => {
      if (result == AdministrationResultStatus.Success || result == AdministrationResultStatus.ServerError) {
        this._snackBarService.callSnackBar(result, result == AdministrationResultStatus.Success ? 'UserAddSuccess' : 'UserAddFail')
        this.closePopup();
      } else if (result == AdministrationResultStatus.UsernameAlreadyTaken || result == AdministrationResultStatus.EmailAlreadyTaken) {
        this.showError = true;
      }
    }) :
      this.profileService.editUser(userProfileData).subscribe(result => {
        if (result == AdministrationResultStatus.Success || result == AdministrationResultStatus.ServerError) {
          this._snackBarService.callSnackBar(result, result == AdministrationResultStatus.Success ? 'UserEditSuccess' : 'UserEditFail')
          this.closePopup();
        } else if (result == AdministrationResultStatus.UsernameAlreadyTaken || result == AdministrationResultStatus.EmailAlreadyTaken) {
          this.showError = true;
        }
      })

  }

  retrieveServicesByCategoryId(category: number) {
    this.serviceCategoryService.retriveServiceCategoryById(category).subscribe(result => {
      result.content?.services?.forEach(x => {
        let employeeService = new EmployeeServiceData();
        employeeService.serviceId = x.id;
        employeeService.serviceCategoryId = category;
        this.employeeServices.push(employeeService);
      })
    })

  }

  onRoleChanged(event: any) {
    if (event.value == 3) {
      this.serviceCategoryService.retrieveAllServiceCategories().subscribe(result => {
        if (result.status == AdministrationResultStatus.Success) {
          this.serviceCategories = result.content?.items!;
          this.showServiceCategories = true;
        }
      })
    } else {
      this.showServiceCategories = false;
    }
    this.showError = false;
  }

  selectServiceCategory(categoryId: number) {
    let existing = this.chosenCategories.filter(x => x == categoryId);
    if (existing.length == 0) {
      this.chosenCategories.push(categoryId)
      this.retrieveServicesByCategoryId(categoryId)
    } else {
      this.chosenCategories = this.chosenCategories.filter(x => x != categoryId)
      this.employeeServices = this.employeeServices.filter(x => x.serviceCategoryId != categoryId);
    }
  }

  closePopup() {
    this.close.emit();
  }

  isCategoryChosen(categoryId: number) {
    return this.chosenCategories.filter(x => x == categoryId).length != 0
  }
}
